import React from "react";
import { guarantee } from "../data/salesCopy";
export function Guarantee() {
  return <section id="garantia" className="scroll-mt-4 bg-card py-8 md:py-16" data-id="element-111" data-mp="1o46kamqgrqwm">
      <div className="mx-auto flex max-w-4xl items-center gap-4 px-5 md:gap-8" data-id="element-112" data-mp="1o5zqk0x60943">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-[3px] border-dashed border-pencil bg-pencil-soft md:h-36 md:w-36 md:border-4" data-id="element-113" data-mp="222mz70yhcnpu">
          <span className="font-display text-lg font-extrabold text-chalk md:text-3xl" data-id="element-114" data-mp="19fadet058jxl">{guarantee.days}</span>
          <span className="text-[8px] font-bold md:text-xs" data-id="element-115" data-mp="14hh8e3aktvyw">{guarantee.label}</span>
        </div>
        <div data-id="element-116" data-mp="1j5va2aw9bedv">
          <h2 className="font-display text-lg font-bold leading-snug md:text-3xl" data-id="element-117" data-mp="1j6n3pg6an21i">{guarantee.title}</h2>
          <p className="mt-1.5 text-[13px] leading-relaxed text-muted md:mt-3 md:text-lg" data-id="element-118" data-mp="1ec0sbd07p9hf">{guarantee.text}</p>
        </div>
      </div>
    </section>;
}